/**
 * The fog blur's radius, kept in tiles so the look is the same at every picture scale (ADR-100 decision 62).
 */

export const FOG_BLUR_TILES = 2;

const MIN_RADIUS = 1;

/**
 * The blur radius in pixels at a picture scale.
 *
 * @param scale Pixels per tile of the picture, a positive finite number.
 * @returns `FOG_BLUR_TILES` tiles in pixels, rounded to a whole pixel and never below 1.
 * @throws RangeError when the scale is not a positive finite number.
 */
export function fogBlurRadius(scale: number): number {
  if (!Number.isFinite(scale) || scale <= 0) {
    throw new RangeError(`scale must be a positive finite number, received ${String(scale)}`);
  }
  return Math.max(MIN_RADIUS, Math.round(FOG_BLUR_TILES * scale));
}
